import styled from "styled-components";

export const Container = styled.nav`
  padding-top: 12px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: 100%;
`;
